package com.patronat.top.ui.organisms.venue

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.models.VenueServiceItemData
import com.patronat.top.ui.molecules.header.SectionCardHeader
import com.patronat.top.ui.molecules.inputs.AppInput
import com.patronat.top.ui.molecules.inputs.AppTextArea
import com.patronat.top.ui.theme.AccentPink
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.VenueDescriptionText
import com.patronat.top.ui.theme.VenueInputLabelText
import com.patronat.top.ui.theme.VenueSectionTitleText
import com.patronat.top.ui.theme.White

@Composable
fun ServiceItemCard(
    service: VenueServiceItemData,
    onServiceChange: (VenueServiceItemData) -> Unit,
    onRemoveClick: () -> Unit,
    modifier: Modifier = Modifier,
    title: String = "Послуга, страва з меню і т.д.",
    nameLabel: String = "Назва послуги",
    priceLabel: String = "Ціна",
    currencyLabel: String = "Валюта",
    descriptionLabel: String = "Опис",
    namePlaceholder: String = "Введіть назву послуги",
    pricePlaceholder: String = "0 грн",
    currencyPlaceholder: String = "UAH",
    descriptionPlaceholder: String = "Введіть опис послуги",
    leadingIcon: Painter? = null,
    removeIcon: Painter? = AppIcons.Close,
    fieldLeadingIcon: Painter? = null
) {
    val borderColor = if (service.hasError) AccentPink else MineShaft100

    Column(
        modifier = modifier
            .fillMaxWidth()
            .background(White, androidx.compose.foundation.shape.RoundedCornerShape(12.dp))
            .border(1.dp, borderColor, androidx.compose.foundation.shape.RoundedCornerShape(12.dp))
            .padding(12.dp)
    ) {
        SectionCardHeader(
            title = title,
            leadingIcon = leadingIcon,
            trailingIcon = removeIcon,
            onTrailingClick = onRemoveClick,
            titleStyle = VenueSectionTitleText,
            titleColor = MineShaft950
        )

        Spacer(modifier = Modifier.height(12.dp))

        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            val compact = maxWidth < 760.dp

            if (compact) {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    AppInput(
                        label = nameLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.name,
                        onValueChange = { onServiceChange(service.copy(name = it)) },
                        placeholder = namePlaceholder,
                        leadingIcon = fieldLeadingIcon
                    )

                    AppInput(
                        label = priceLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.price,
                        onValueChange = { onServiceChange(service.copy(price = it)) },
                        placeholder = pricePlaceholder,
                        leadingIcon = fieldLeadingIcon,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal)
                    )

                    AppInput(
                        label = currencyLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.currency,
                        onValueChange = { onServiceChange(service.copy(currency = it)) },
                        placeholder = currencyPlaceholder,
                        leadingIcon = fieldLeadingIcon
                    )
                }
            } else {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    AppInput(
                        label = nameLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.name,
                        onValueChange = { onServiceChange(service.copy(name = it)) },
                        placeholder = namePlaceholder,
                        leadingIcon = fieldLeadingIcon,
                        modifier = Modifier.weight(2f)
                    )

                    AppInput(
                        label = priceLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.price,
                        onValueChange = { onServiceChange(service.copy(price = it)) },
                        placeholder = pricePlaceholder,
                        leadingIcon = fieldLeadingIcon,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        modifier = Modifier.weight(1f)
                    )

                    AppInput(
                        label = currencyLabel,
                        labelTextStyle = VenueInputLabelText,
                        value = service.currency,
                        onValueChange = { onServiceChange(service.copy(currency = it)) },
                        placeholder = currencyPlaceholder,
                        leadingIcon = fieldLeadingIcon,
                        modifier = Modifier.weight(1f)
                    )
                }
            }
        }

        Spacer(modifier = Modifier.height(12.dp))

        AppTextArea(
            label = descriptionLabel,
            labelTextStyle = VenueInputLabelText,
            contentTextStyle = VenueDescriptionText,
            value = service.description,
            onValueChange = { onServiceChange(service.copy(description = it)) },
            placeholder = descriptionPlaceholder,
            minHeight = 110.dp
        )
    }
}
